import React from 'react';
import {formatCurrency} from '../../helpers/utils';

export default function MetricsModule({metrics}) {
  return (
    <>
      <div className="card-deck mt-3">
        <div className="card">
          <div className="card-body p-2">
            <div className="d-flex justify-content-between">
              <div>
                <h5 className="m-0 p-2">{'Total SignUps'}</h5>
              </div>
              {/* <div className="my-auto">
                <span className="badge badge-primary">
                  {`${metrics.referralCountYTD} YTD`}
                </span>
              </div> */}
            </div>
            <div className="px-2">
              <h2 className="text-primary">{metrics.referralCount}</h2>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body p-2">
            <div className="d-flex justify-content-between">
              <div>
                <h5 className="m-0 p-2">{'Total Subscriptions'}</h5>
              </div>
              <div className="my-auto">
                <span className="badge badge-success">{'Active'}</span>
              </div>
            </div>
            <div className="px-2">
              <h2 className="text-success">{metrics.subscriptionCount}</h2>
            </div>
          </div>
        </div>
    {/* <div className="card">
          <div className="card-body p-2">
            <div className="d-flex justify-content-between">
              <div>
                <h5 className="m-0 p-2">{'KYC Pending'}</h5>
              </div>
              <div className="my-auto">
                <span className="badge badge-danger">{'Action Required'}</span>
              </div>
            </div>
            <div className="px-2">
              <h2 className="text-danger">{metrics.kycPendingAccounts}</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="card-deck mt-3">
        <div className="card">
          <div className="card-body p-2">
            <div className="d-flex justify-content-between">
              <div>
                <h5 className="m-0 p-2">{'Total Orders Placed'}</h5>
              </div>
            </div>
            <div className="px-2">
              <h2 className="text-primary">{metrics.orders.count}</h2>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body p-2">
            <div className="d-flex justify-content-between">
              <div>
                <h5 className="m-0 p-2">{'Total Revenue'}</h5>
              </div>
            </div>
            <div className="px-2">
              <h2 className="text-primary">
                {formatCurrency(metrics.orders.orderRevenue)}
              </h2>
            </div>
          </div>
        </div>
       */ }
        <div className="card">
          <div className="card-body p-2">
            <div className="d-flex justify-content-between">
              <div>
                <h5 className="m-0 p-2">{'Payout'}</h5>
              </div>
              {/* <div className="my-auto">
                <span className="badge badge-primary">
                  {`${formatCurrency(metrics.payOutYTD)} YTD`}
                </span>
              </div> */}
            </div>
            <div className="px-2">
              <h2 className="text-primary">{formatCurrency(metrics.payOut)}</h2>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
